import i18n from "i18next";
import {initReactI18next} from "react-i18next";
import en from "./locales/en.json";
import de from "./locales/de.json";

export const supportedLngs = {
    en: "EN",
    de: "DE",
};

i18n
    .use(initReactI18next)
    .init({
        // Specifies the default language (locale) used
        lng: "de",

        // Fallback locale used when a translation is
        // missing in the active locale. Again, use your
        // preferred locale here.
        fallbackLng: "en",

        supportedLngs: Object.keys(supportedLngs),

        // Enables useful output in the browser’s
        // dev console.
        debug: true,

        interpolation: {
            escapeValue: false,
        },

        resources: {
            en: {
                translation: en

            },
            de: {
                translation: de,
            },
        },
    });

export default i18n;